var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Activate',{attrs:{"invite":_vm.invite,"loader":_vm.loader,"disableForm":_vm.disableForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }